import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { NavLink } from "react-router-dom";
import {
  getNotification,
  markNotificationAsRead,
  getBookingAddress,
  startChargingVehicle,
  stopChargingVehicle,
  getChargeBoxCharging
} from "../../actions/commonActions";
import "../../css/style-starter.css";
import moment from "moment";
import BookingDetail from "../Shared/BookingDetail";

const NOTIFICATIONS_DATE_FORMAT = "YYYY-MM-DD hh:mm A";
const BOOKING_DAY_FORMAT = "h:mm A";
const BOOKING_DATE_FORMAT = "MMMM D, dddd";

export default function Home() {
  // Read from Redux
  const dispatch = useDispatch();
  const {
    driverNotifications,
    bookingAddress,
    bookingAddressStatus,
    isCharging
  } = useSelector((redux) => redux.common);
  //  ==========

  // State Variables
  const [notificationClicked, setNotificationClicked] = useState(false);
  const [vehicleChargingStarted, setvehicleChargingStarted] = useState(false);
  const [tagId, settagId] = useState(localStorage.getItem("tag_id"));
  const [activeSlide, setActiveSlide] = useState(0);
  const [chargingArr, setChargingArr] = useState([]);
  const [nowCharging,setNowCharging]=useState(false)
  const [disableButton, setDisableButton] = useState(false);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    swipeToSlide: true,
    infinite: false,
    // slidesToScroll: 1,
    afterChange: (current) => setActiveSlide(current),
  };

  // console.log("HOME VALUE CHECK:", { bookingAddress })
  // console.log("ACTIVE SLIDE VALUE", activeSlide)

  // const [address, setAddress] = useState({
  //   country: "",
  //   state: "",
  //   city: "",
  //   street_line_1: "",
  //   street_line_2: "",
  //   bundle_name: "",
  //   parking_slot_id: "",
  //   start_date_time: "",
  //   charge_box_id: "",
  //   connector_id: "",
  //   parking_slot_booking_id: ""
  // });

  const [addressNew, setAddressNew] = useState([]);

  const [userName, setUserName] = useState({
    first_name: "",
    last_name: "",
  });

  const [driverId, setDriverId] = useState("");
  // ===============

  

  useEffect(() => {
    if (notificationClicked) {
      getNotification(dispatch, driverId);
      setNotificationClicked(false);
    }
  }, [notificationClicked]);

  // useEffect(() => {
  //   if (bookingAddress && bookingAddress.length > 0) {
  //     setAddress({
  //       ...address,
  //       country: bookingAddress[0].address.country.name,
  //       state:
  //         (bookingAddress[0].address.state &&
  //           bookingAddress[0].address.state.name) ||
  //         "",
  //       city: bookingAddress[0].address.city.name,
  //       street_line_1: bookingAddress[0].address.street_line_1,
  //       street_line_2: bookingAddress[0].address.street_line_2,
  //       bundle_name: bookingAddress[0].bundle_name,
  //       visible_number: bookingAddress[0].visible_number,
  //       start_date_time: bookingAddress[0].start_date_time,
  //       end_date_time: bookingAddress[0].end_date_time,
  //       charge_box_id: bookingAddress[0].charge_box_id,
  //       connector_id: bookingAddress[0].connector_id,
  //       parking_slot_booking_id: bookingAddress[0].parking_slot_booking_id
  //     });
  //   }
  //   getChargeBoxCharging(dispatch, bookingAddress[0]?.charge_box_id);
  // }, [bookingAddress]);

  // useEffect(() => {
  //   if (bookingAddress && bookingAddress.length > 0) {
  //     bookingAddress.map(booking => {
  //       getChargeBoxCharging(dispatch, booking.charge_box_id, setChargingArr, booking.parking_slot_booking_id);
  //       // setChargingArr((prevState) => [...prevState, {
  //       //   parking_slot_booking_id: booking.parking_slot_booking_id,
  //       //   isCharging: isCharging
  //       // }])
  //     })
  //   }
  // }, [bookingAddress])

  console.log("isCharging",isCharging)

  useEffect(() => {
    if (bookingAddress && bookingAddress.length > 0) {
      bookingAddress.map((booking) => {
        // getChargeBoxCharging(dispatch, booking.charge_box_id);
        setChargingArr((prevState) => [...prevState, {
          parking_slot_booking_id: booking.parking_slot_booking_id,
          isCharging: isCharging
        }])

        setAddressNew((prevState) => [...prevState, {
          country: booking.address.country.name,
          state:
            (booking.address.state &&
              booking.address.state.name) ||
            "",
          city: booking.address.city.name,
          street_line_1: booking.address.street_line_1,
          street_line_2: booking.address.street_line_2,
          bundle_name: booking.bundle_name,
          visible_number: booking.visible_number,
          start_date_time: booking.start_date_time,
          end_date_time: booking.end_date_time,
          charge_box_id: booking.charge_box_id,
          connector_id: booking.connector_id,
          parking_slot_booking_id: booking.parking_slot_booking_id,
          chargeOn: isCharging
        }])


      })

    }
    // getChargeBoxCharging(dispatch, bookingAddress[0]?.charge_box_id);
  }, [bookingAddress]);

  // console.log("Address Value check:", { address, addressNew, chargingArr })

  const unReadNotificationClicked = (notificationId, e) => {
    markNotificationAsRead(dispatch, notificationId);
    setNotificationClicked(true);
  };

  let notifications = null;
  notifications = driverNotifications
    .filter((n) => !n.read_date_time)
    .map((notification, index) => {
      return (
        <div
          key={index}
          className="alert alert-notification alert-dismissible fade show"
          role="alert"
          name="hello"
        >
          <p className="notification-date">
            {moment(notification.delivery_date_time).format(
              NOTIFICATIONS_DATE_FORMAT
            )}
          </p>
          <p className="notification-text">{notification.notification_text}</p>
          <button
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="Close"
            name="dasd"
            onClick={(e) =>
              unReadNotificationClicked(
                notification.notification_destination_delivery_id,
                e
              )
            }
          >
            <span className="fa fa-check" aria-hidden="true"></span>
          </button>
        </div>
      );
    });

  const startCharging = () => {
    if (addressNew && addressNew.length > 0) {
      chargingArr[activeSlide].isCharging = true;

      addressNew[activeSlide].chargeOn = true;

      let chargeSlot = chargingArr[activeSlide];
      setDisableButton(true);
      console.log("This spot started:", { activeSlide, chargeSlot, addressNew, chargingArr })
      startChargingVehicle(
        dispatch,
        {
          parking_slot_booking_id: addressNew[activeSlide].parking_slot_booking_id,
          tag_id: tagId,
          connector_id: addressNew[activeSlide].connector_id,
          charge_box_id: addressNew[activeSlide].charge_box_id,
        },
        () => {
          setvehicleChargingStarted(true);
          setDisableButton(true)
          getChargeBoxCharging(dispatch, addressNew[activeSlide].charge_box_id,setNowCharging,setDisableButton);
        }
      );
    } else {
      alert("No valid Booking Available")
    }
  };

  // console.log("Is Charging :", isCharging)
  const stopCharging = () => {
    if (addressNew && addressNew.length > 0) {
      chargingArr[activeSlide].isCharging = false;
      addressNew[activeSlide].chargeOn = false;

      setDisableButton(true);

      let chargeSlot = chargingArr[activeSlide];

      console.log("This spot stoped:", { activeSlide, chargeSlot, addressNew, chargingArr })

      stopChargingVehicle(
        dispatch,
        {
          parking_slot_booking_id: addressNew[activeSlide].parking_slot_booking_id,
          tag_id: tagId,
          connector_id: addressNew[activeSlide].connector_id,
          charge_box_id: addressNew[activeSlide].charge_box_id,
        },
        () => {
          setvehicleChargingStarted(false);
          setDisableButton(true)
          getChargeBoxCharging(dispatch, bookingAddress[activeSlide]?.charge_box_id,setNowCharging,setDisableButton);
        }
      );
    }
  };
  useEffect(() => {
    const driver_id = localStorage.getItem("driver_id");
    setDriverId(driver_id);
    getNotification(dispatch, driver_id);
    getBookingAddress(dispatch, driver_id);
    setUserName({
      first_name: localStorage.getItem("first_name"),
      last_name: localStorage.getItem("last_name"),
    });

  }, []);
useEffect(() => {
 if(bookingAddress.length>0)
 {
  console.log("addressnew",bookingAddress)
  setDisableButton(true)
  getChargeBoxCharging(dispatch, bookingAddress[activeSlide]?.charge_box_id,setNowCharging,setDisableButton);

 }

}, [activeSlide,bookingAddress]);



  return (
    <div className={`cbp-spmenu-push`}>
      <div className="main buttonset">
        <div className="tophny-header">
          <div className="container">
            <div className="hny-topgds">
              <div className="menu-notify"></div>
              <div className="logo text-center">
                <h1>
                  <NavLink className="navbar-brand" to={`/profile/${driverId}`}>
                    {` ${userName.first_name} ${userName.last_name}`}{" "}
                  </NavLink>
                </h1>
              </div>
              {/* <div className="icon-left search-right text-right">
                <NavLink to={`/profile/${driverId}`} className="topuser">
                  <span className="fa fa-user" aria-hidden="true"></span>
                </NavLink>
              </div> */}
            </div>
          </div>
        </div>
        <section className="features-4" id="services">
          <div className="features4-block ">
            <div className="container py-lg-3">
              {notifications && notifications.length > 0 && (
                <div className="features4-grids- text-left row py-2 mb-1">
                  <div className="col-md-12">
                    <div className="features4-grid-inn">
                      <div className="d-flex justify-content-start">
                        <div className="icon-fea4">
                          <span
                            className="fa fa-bell bell-position"
                            aria-hidden="true"
                          ></span>
                          <span className="badge badge-dark unReadNotification-badge">
                            {notifications.length}
                          </span>
                        </div>
                        <h5 className="my-2 ml-2 mt-2">
                          <NavLink to="/notifications">Notifications</NavLink>
                        </h5>
                      </div>
                      <div className="overflow-auto notifications-container">
                        {notifications}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* {...................................} */}

              {addressNew ? (
                <Slider {...settings}>
                  {
                    addressNew.map((address) => (
                      address.country && (
                        <div className="title-head text-center parking-address" style={{
                          width: "100vw"
                        }}>
                          <BookingDetail
                            date={address.start_date_time}
                            dateFormat={BOOKING_DATE_FORMAT}
                            dayFormat={BOOKING_DAY_FORMAT}
                            address={address}
                            showBookingAddress={bookingAddressStatus}
                          />
                        </div>
                      )
                    ))

                  }

                </Slider>) : (
                <NavLink
                  to="/plan_selection"
                  className={`topuser ${bookingAddressStatus ? "d-none" : ""
                    }`}
                >
                  <button type="button" className="btn btn-success">
                    Plan Selection
                  </button>
                </NavLink>
              )
              }
              {/* ........................................... */}

              {/*
              {address && (
                <div className="title-head text-center parking-address">
                  {address.country && (
                    <BookingDetail
                      date={address.start_date_time}
                      dateFormat={BOOKING_DATE_FORMAT}
                      dayFormat={BOOKING_DAY_FORMAT}
                      address={address}
                      showBookingAddress={bookingAddressStatus}
                    />
                  )}

                  <NavLink
                    to="/plan_selection"
                    className={`topuser ${bookingAddressStatus ? "d-none" : ""
                      }`}
                  >
                    <button type="button" className="btn btn-success">
                      Plan Selection
                    </button>
                  </NavLink>
                </div>
              )} */}
            </div>
          </div>
        </section>
        <section className="w3l-content-4">
          <div className="content-4-main py-1">
            <div className="container py-lg-5">
              <div className="title-head text-center mb-4">
                {/* {(vehicleChargingStarted && (
                  <button
                    type="submit"
                    className={`btn btn-stop-charging`}
                    onClick={stopCharging}
                  >
                    Stop
                  </button>
                )) || (
                  <button
                    type="submit"
                    className={`btn btn-primary green-two-bg`}
                    onClick={startCharging}
                  >
                    Start
                  </button>
                )} */}

                {
                  nowCharging? (
                    <button
                      type="submit"
                      className={`btn btn-stop-charging btn_wht_cap`}
                      onClick={stopCharging}
                      disabled={disableButton}
                      style={{ cursor: disableButton ? "not-allowed" : "pointer" }}

                    >
                      Stop
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className={`btn btn-primary green-two-bg btn_wht_cap`}
                      onClick={startCharging}
                      disabled={disableButton}
                      style={{ cursor: disableButton ? "not-allowed" : "pointer" }} 

                    >
                      Start
                    </button>
                  )
                }
                <NavLink
                  to="/my_schedule"
                  className="btn btn-style-1 btn-primary mt-2 "
                >
                  MY SCHEDULE
                </NavLink>
                <NavLink
                  to="/contact"
                  className="btn btn-style-1 btn-primary mt-2"
                >
                  CONTACT STATION MANAGER
                </NavLink>
              </div>
            </div>
          </div>
        </section>
      </div>


    </div>
  );
}
